import { AuthProvider, RecoverPasswordPage as AuthRecoverPasswordPage } from '@hub-la/fe-auth'

export const RecoverPasswordInit = () => {
  return (
    <AuthProvider>
      <AuthRecoverPasswordPage />
    </AuthProvider>
  )
}
